import React from 'react';
import { IconLibrary } from '../../../interfaces/icon/IconLibrary';
import IconButton from './IconButton';
import { IMinimiseButton } from '../../../interfaces/buttons/buttons';

const MinimiseButton = ({ ariaLabel, className, isDisabled = false, onButtonClick, text, hideText=false}: IMinimiseButton) => {
    return (
        <div className='minimise-button-wrapper'>
            {!hideText && 
                <div className='minimise-button-text'>
                    {text || "Minimise"}
                </div>
            }

            <IconButton 
                className={`icon-button-squared minimise-button ${className}`}
                ariaLabel={ariaLabel} 
                iconName={IconLibrary.DASH}   
                isDisabled={isDisabled}
                onButtonClick={onButtonClick}        
            />
        </div>
    );
};

export default MinimiseButton